import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue'),
            meta: {
                title: 'Home',
                icon: 'home',
                main: true,
                secure: false
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue'),
            meta: {
                title: 'Accedi',
                icon: 'lock',
                main: false,
                secure: false
            }
        },
        {
            path: '/clienti',
            name: 'customers',
            component: () => import('./views/Customers.vue'),
            meta: {
                title: 'Clienti',
                icon: 'group',
                main: true,
                secure: false
            }
        },
        {
            path: '/clienti/nuovo',
            name: 'customerAdd',
            component: () => import('./views/CustomerAdd.vue'),
            meta: {
                title: 'Crea cliente',
                icon: 'group',
                main: false,
                secure: false
            }
        },
        {
            path: '/clienti/:customerId',
            name: 'customer',
            component: () => import('./views/Customer.vue'),
            meta: {
                title: 'Cliente',
                icon: 'group',
                main: false,
                secure: false
            }
        },
        {
            path: '/animali/:petId',
            name: 'pet',
            component: () => import('./views/Pet.vue'),
            meta: {
                title: 'Animale',
                icon: 'group',
                main: false,
                secure: false
            }
        },
        {
            path: '/clienti/:customerId/animali/nuovo',
            name: 'petAdd',
            component: () => import('./views/PetAdd.vue'),
            meta: {
                title: 'Crea animale',
                icon: 'group',
                main: false,
                secure: false
            }
        },
        {
            path: '/animali/:petId/modifica',
            name: 'petEdit',
            component: () => import('./views/PetEdit.vue'),
            meta: {
                title: 'Modifica animale',
                icon: 'group',
                main: false,
                secure: false
            }
        },
        {
            path: '/clienti/:customerId/modifica',
            name: 'customerEdit',
            component: () => import('./views/CustomerEdit.vue'),
            meta: {
                title: 'Modifica cliente',
                icon: 'group',
                main: false,
                secure: false
            }
        },
        {
            path: '/servizi',
            name: 'services',
            component: () => import('./views/Services.vue'),
            meta: {
                title: 'Servizi',
                icon: 'room_service',
                main: true,
                secure: false
            }
        },
        {
            path: '/appuntamenti',
            name: 'appointments',
            component: () => import('./views/Appointments.vue'),
            meta: {
                title: 'Appuntamenti',
                icon: 'event',
                main: true,
                secure: false
            }
        },
        {
            path: '/pensione',
            name: 'Pensione',
            component: () => import('./views/Pensione.vue'),
            meta: {
                title: 'Pensione',
                icon: 'description',
                main: true,
                secure: false
            }
        },
        {
            path: '/asilo',
            name: 'Asilo',
            component: () => import('./views/Asilo.vue'),
            meta: {
                title: 'Asilo',
                icon: 'description',
                main: true,
                secure: false
            }
        },
        {
            path: '/allevamento',
            name: 'Allevamento',
            component: () => import('./views/Allevamento.vue'),
            meta: {
                title: 'Allevamento',
                icon: 'pets',
                main: true,
                secure: false
            }
        },
        {
            path: '/allevamento/animali/nuovo',
            name: 'AllevamentoPetAdd',
            component: () => import('./views/AllevamentoPetAdd.vue'),
            meta: {
                title: 'Crea animale',
                icon: 'pets',
                main: false,
                secure: false
            }
        },
        {
            path: '/401',
            component: () => import('./views/401.vue'),
            meta: {
                title: 'nopermission',
                icon: null,
                main: false,
                secure: false
            }
        },
        {
            path: '*',
            component: () => import('./views/404.vue'),
            meta: {
                title: 'notfound',
                icon: null,
                main: false,
                secure: false
            }
        }

    ]
})
